// extracted by mini-css-extract-plugin
export default {"major-card":"MajorCard_major-card__IIcjX","text-view":"MajorCard_text-view__cYVG6","title":"MajorCard_title__uy2Qs"};